import React, { FC, useState } from 'react';

import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Link, Typography } from '@mui/material';
import { Helmet } from 'react-helmet';

const faqList = [
  {
    title: 'Does Themis govern Pegaxy?',
    text: 'Currently it does not. It’s primary use-case is a centralized platform for users to submit, vote and comment on suggestions from the community. In short, it is a community voting and sentiment platform.',
  },
  {
    title: 'How are votes calculated?',
    text: 'Initially, Themis takes direct PGX vs. PGX values. This is done to keep the platform simple and easy to use. However, in the future voting formula will be introduced (for example Quadratic voting), to increase the platforms security and reliability.',
  },
  {
    title: 'Does a winning or losing proposal guarantee implementation?',
    text: 'No. Themis is a moderated and centralized platform designed to give the community a singular point of discussion for in-game proposals. Decentralization of Pegaxy is many years away, and guaranteeing implementation of proposals in current stage is highly ineffective.',
  },
  {
    title: 'Once I submit my vote, can I change it?',
    text: 'Yes, you can change your vote if the countdown timer on the proposal has time remaining. Once the timer hits zero, votes will be snapshotted and you will no longer be able to change your vote.',
  },
  {
    title: 'How do I know the team did not manipulate a vote?',
    text: 'All team wallets are registered and visible on Themis. When a team member comments, votes or submits a proposal, the community will be able to see this via an “earmark” on the proposal, comment or vote.',
  },
  {
    title: 'Do you have a tutorial video for using Themis?',
    text: (
      <>
        Yes, you can find it{' '}
        <Link href="https://www.youtube.com/watch?v=HlGIKHKtLYI" target="_blank">
          here
        </Link>
      </>
    ),
  },
];

export const FaqPage: FC = () => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <Helmet>
        <title>FAQ | Pegaxy Themis</title>
      </Helmet>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pb: 6,
          pt: 8,
        }}
      >
        <Container maxWidth="md">
          <Box sx={{ mb: 4 }}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body1" color="text.secondary" fontWeight="bold">
                FAQs
              </Typography>
              <Typography variant="h3">Frequently Asked Questions</Typography>
            </Box>
            <Box sx={{ p: 2, pt: 6 }}>
              {faqList.map((question, key) => (
                <Accordion expanded={expanded === `painel${key}`} onChange={handleChange(`painel${key}`)}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography fontWeight="bold" sx={{ my: 1 }}>
                      {question.title}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography color="text.secondary" sx={{ mb: 2 }}>
                      {question.text}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};
